angular.module('eventAnalysisEchartModule', [])
    .directive('pileLineChartDir', ['$q', '$timeout', 'trsHttpService', function($q, $timeout, trsHttpService) {
        return {
            restrict: 'E',
            replace: true,
            template: "<div ng-style=\"myStyle\" ng-click=\"request(params)\"></div>",
            scope: {
                optionJsons: "="
            },
            link: function(scope, iElement, iAttrs) {
                $timeout(function() {
                    scope.myStyle = {
                        height: '300px',
                        width: '100%'
                    };
                    scope.mediaChannel = {
                        'app': '客户端',
                        'wx': '微信',
                        'wz': '网站',
                        'szb': '数字报',
                    };
                    var myChart;
                    scope.$watch("optionJsons", function(newVal, oldVal) {
                        if (typeof newVal == 'object' && newVal != oldVal) {
                            if (angular.isDefined(scope.optionJsons)) {
                                var optionData = scope.optionJsons.reverse(),
                                    xAiaData = [];
                                var appData = [],
                                    wxData = [],
                                    wzData = [],
                                    szbData = [];
                                for (var i = 0; i < optionData.length; i++) {
                                    xAiaData.push(optionData[i][0].date);
                                    appData.push(optionData[i][1].data.app);
                                    wxData.push(optionData[i][1].data.wx);
                                    wzData.push(optionData[i][1].data.wz);
                                    szbData.push(optionData[i][1].data.szb);
                                }
                                var option = {
                                    tooltip: {
                                        trigger: 'axis',
                                        axisPointer: {
                                            type: 'cross',
                                            label: {
                                                backgroundColor: '#6a7985'
                                            }
                                        }
                                    },
                                    legend: {
                                        icon: 'rect',
                                        top: '15',
                                        data: ['客户端', '微信', '网站', '数字报']
                                    },
                                    grid: {
                                        left: '3%',
                                        right: '4%',
                                        bottom: '5%',
                                        containLabel: true
                                    },
                                    xAxis: [{
                                        type: 'category',
                                        boundaryGap: false,
                                        data: xAiaData
                                    }],
                                    yAxis: [{
                                        type: 'value',
                                    }],
                                    series: [{
                                            name: '客户端',
                                            type: 'line',
                                            stack: '总量',
                                            color: ['#A2DAFF'],
                                            areaStyle: { normal: {} },
                                            data: appData,
                                        },
                                        {
                                            name: '微信',
                                            type: 'line',
                                            stack: '总量',
                                            areaStyle: { normal: {} },
                                            color: ['#F7845D'],
                                            data: wxData,
                                        },
                                        {
                                            name: '网站',
                                            type: 'line',
                                            stack: '总量',
                                            color: ['#F9D772'],
                                            areaStyle: { normal: {} },
                                            data: wzData
                                        },
                                        {
                                            name: '数字报',
                                            type: 'line',
                                            stack: '总量',
                                            color: ['#598FF8 '],
                                            label: {
                                                normal: {
                                                    show: true,
                                                    position: 'top'
                                                }
                                            },
                                            areaStyle: { normal: {} },
                                            data: szbData
                                        }
                                    ]
                                };
                                require(['echarts'], function(echarts) {
                                    if (myChart != null && myChart != "" && myChart != undefined) {
                                        myChart.dispose();
                                    }
                                    myChart = echarts.init(iElement[0]);
                                    myChart.setOption(option);
                                    window.addEventListener("resize", function() {
                                        myChart.resize();
                                    });
                                });
                            }
                        }
                    });

                }, 100);
            }
        };
    }])
    .directive('nestPieChartDir', ['$q', '$timeout', 'trsHttpService', function($q, $timeout, trsHttpService) {
        // Runs during compile
        return {
            restrict: 'E',
            replace: true,
            template: "<div ng-style=\"myStyle\" ng-click=\"request(params)\"></div>",
            scope: {
                innerOption: "=",
                outOption: '=',
                innerIndex:'=',
            },
            link: function(scope, iElement, iAttrs, $watch) {
                $timeout(function() {
                    scope.myStyle = {
                        height: '418px',
                        width: '100%'
                    };
                    scope.mediaChannel = {
                        '客户端': 'app',
                        '微信': 'wx',
                        '网站': 'wz',
                        '报纸': 'szb',
                    };
                    var myChart;
                    scope.$watch("outOption", function(newVal, oldVal) {
                        if (typeof newVal == 'object' && newVal != oldVal) {
                            if (angular.isDefined(scope.outOption)) {
                                var innerData = scope.innerOption,
                                    outData = scope.outOption;
                                var legendData = [];
                                for (var i = 0; i < innerData.length; i++) {
                                    legendData.push(innerData[i].name);
                                    innerData[i].index=i;
                                }
                                var option = {
                                    tooltip: {
                                        trigger: 'item',
                                        formatter: "{a} <br/>{b}: {c} ({d}%)",
                                    },
                                    legend: {
                                        icon: 'rect',
                                        orient: 'horizontal',
                                        x: '50',
                                        backgroundColor: '#fff',
                                        data: legendData
                                    },
                                    series: [{
                                            name: '来源',
                                            type: 'pie',
                                            selectedMode: 'single',
                                            radius: [0, '38%'],
                                            label: {
                                                normal: {
                                                    formatter: function(data) {
                                                        return data.percent + '%' + '\n' + data.name;
                                                    },
                                                    position: 'out',
                                                    fontSize: 12,
                                                }
                                            },
                                            labelLine: {
                                                normal: {
                                                    lineStyle: {
                                                        color: 'transparent'
                                                    },
                                                    smooth: 0.4,
                                                    length: 18,
                                                    length2: 12
                                                }
                                            },
                                            color: ['#9092F7', '#F76280', '#FFBE5C ', '#A7D265 ', '#477FEA'],
                                            data: innerData,
                                        },
                                        {
                                            name: '来源',
                                            type: 'pie',
                                            radius: ['72%', '78%'],
                                            label: {
                                                normal: {
                                                    formatter: function(data) {
                                                        return data.value + '\n' + data.name;
                                                    },
                                                    position: 'out',
                                                    fontSize: 16,
                                                }
                                            },
                                            labelLine: {
                                                normal: {
                                                    lineStyle: {
                                                        color: 'transparent'
                                                    },
                                                    smooth: 0.3,
                                                    length: 12,
                                                    length2: 12
                                                }
                                            },
                                            color: ['#477FEA', '#739DEF', '#90B2F2', '#9FBDF5', '#DAE5FB'],
                                            data: outData
                                        }
                                    ]
                                };
                                require(['echarts'], function(echarts) {
                                    if (myChart != null && myChart != "" && myChart != undefined) {
                                        myChart.dispose();
                                    }
                                    myChart = echarts.init(iElement[0]);
                                    myChart.setOption(option);
                                    myChart.dispatchAction({type: 'highlight',seriesIndex: 0,dataIndex:scope.innerIndex});
                                    myChart.on("click", function(param) {
                                        var channel = param.name;
                                        if (channel == '自媒体' || channel == '官方媒体' || channel == '商业媒体' || channel == '政府机构' || channel == '社会团体') {
                                            return;
                                        }
                                        scope.$emit('changeChannel', { channel: scope.mediaChannel[channel],innerIndex:param.data.index });
                                    });
                                    window.addEventListener("resize", function() {
                                        myChart.resize();
                                    });
                                });
                            }
                        }
                    });

                }, 100);
            }
        };
    }])
    .directive('basicPieChartDir', ['$q', '$timeout', 'trsHttpService', function($q, $timeout, trsHttpService) {
        // Runs during compile
        return {
            restrict: 'E',
            replace: true,
            template: "<div ng-style=\"myStyle\" ng-click=\"request(params)\"></div>",
            scope: {
                optionData: "="
            },
            link: function(scope, iElement, iAttrs) {
                $timeout(function() {
                    scope.myStyle = {
                        height: '380px',
                        width: '100%'
                    };
                    scope.type = {
                        '官方媒体': 'official',
                        '其他媒体': 'folk'
                    };
                    var myChart;
                    scope.$watch("optionData", function(newVal, oldVal) {
                        if (typeof newVal == 'object') {
                            if (angular.isDefined(scope.optionData)) {
                                scope.seriesData = [];
                                scope.seriesData[0] = {
                                    value: scope.optionData.officialNum,
                                    name: scope.optionData.officialName,
                                    selected: true
                                };
                                scope.seriesData[1] = {
                                    value: scope.optionData.folkNum,
                                    name: scope.optionData.folkName
                                };
                                var option = {
                                    tooltip: {
                                        trigger: 'item',
                                        formatter: "{a} <br/>{b} : {c} ({d}%)",
                                        position: ['50%', '50%'],
                                    },
                                    legend: {
                                        icon: 'rect',
                                        orient: 'horizontal',
                                        left: '0',
                                        data: ['官方媒体', '其他媒体']
                                    },
                                    series: [{
                                        name: '访问来源',
                                        type: 'pie',
                                        radius: '55%',
                                        center: ['50%', '40%'],
                                        data: scope.seriesData,
                                        color: ['#419CFF', '#B5CEF7'],
                                        itemStyle: {
                                            emphasis: {
                                                shadowBlur: 10,
                                                shadowOffsetX: 0,
                                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                                            }
                                        }
                                    }]
                                };
                                require(['echarts'], function(echarts) {
                                    if (myChart != null && myChart != "" && myChart != undefined) {
                                        myChart.dispose();
                                    }
                                    myChart = echarts.init(iElement[0]);
                                    myChart.setOption(option);
                                    myChart.on("click", function(param) {
                                        var type = param.name;
                                        scope.$emit('changeTypeData', { type: scope.type[type] });
                                    });
                                    window.addEventListener("resize", function() {
                                        myChart.resize();
                                    });
                                });

                            }
                        }
                    });
                }, 1000);
            }
        };
    }])
    .directive('basicLineChartDir', ['$q', '$timeout', 'trsHttpService', function($q, $timeout, trsHttpService) {
        return {
            restrict: 'E',
            replace: true,
            template: "<div ng-style=\"myStyle\" ng-click=\"request(params)\"></div>",
            scope: {
                optionJsons: "="
            },
            link: function(scope, iElement, iAttrs, $eval, $rootScope) {
                $timeout(function() {
                    scope.myStyle = {
                        height: '330px',
                        width: '100%'
                    };
                    var myChart;
                    scope.$watch("optionJsons", function(newVal, oldVal) {
                        if (typeof newVal == 'string') {
                            if (angular.isDefined(scope.optionJsons)) {
                                var xAisData = [],
                                    yAisData = [];
                                var optionsData = angular.fromJson(JSON.parse(scope.optionJsons));
                                for (var i = 0; i < optionsData.length; i++) {
                                    if (!(Object.keys(optionsData[i][0]).length == 0 || Object.keys(optionsData[i][1]).length == 0)) {
                                        for (var y = 0, yData; yData = optionsData[i][1].data, y < yData.length; y++) {
                                            xAisData.push(optionsData[i][0].date + ' ' + yData[y].strValue + ':00');
                                            yAisData.push(yData[y].iRecordNum);
                                        }
                                    }
                                }
                                var option = {
                                    tooltip: {
                                        trigger: 'axis',
                                        position: function(pt) {
                                            return [pt[0], '10%'];
                                        }
                                    },
                                    legend: {
                                        icon: 'rect',
                                        orient: 'horizontal',
                                        left: '50',
                                        data: ['报道量'],
                                    },
                                    grid: [{
                                            left: '10%',
                                            right: '8%',
                                            height: '60%'
                                        },
                                        {
                                            left: '10%',
                                            right: '8%',
                                            top: '63%',
                                            height: '16%'
                                        }
                                    ],
                                    dataZoom: [{
                                            type: 'inside',
                                            start: 0,
                                            end: 100
                                        },
                                        {
                                            show: true,
                                            type: 'slider',
                                            top: '85%',
                                            start: 0,
                                            end: 100
                                        }
                                    ],
                                    xAxis: {
                                        type: 'category',
                                        boundaryGap: false,
                                        axisTick: {
                                            show: false
                                        },
                                        gridIndex: 0,
                                        data: xAisData,

                                    },
                                    yAxis: {
                                        type: 'value',
                                        gridIndex: 0,
                                        axisTick: {
                                            show: false
                                        }
                                    },
                                    series: [{
                                        name: '报道量',
                                        data: yAisData,
                                        color: ['#E3EDFF'],
                                        type: 'line',
                                        itemStyle: {
                                            normal: {
                                                color: '#d64541'
                                            }
                                        },
                                        areaStyle: {
                                            normal: {
                                                color: '#e9f1ff'
                                            }
                                        },
                                    }]
                                };
                                require(['echarts'], function(echarts) {
                                    if (myChart != null && myChart != "" && myChart != undefined) {
                                        myChart.dispose();
                                    }
                                    myChart = echarts.init(iElement[0]);
                                    myChart.setOption(option);
                                    var promise;
                                    myChart.on('dataZoom', function(data) {
                                        if (promise) {
                                            $timeout.cancel(promise);
                                            promise = null;
                                        }
                                        promise = $timeout(function() {
                                            var option = myChart.getOption();
                                            var dz = option.dataZoom[0];
                                            var startValue = option.xAxis[0].data[dz.startValue];
                                            var endValue = option.xAxis[0].data[dz.endValue];
                                            var timeValue = {
                                                startValue: startValue,
                                                endValue: endValue
                                            };
                                            scope.$emit('changeTimeRangeData', { timeValue: timeValue });
                                        }, 500);
                                    });
                                    window.addEventListener("resize", function() {
                                        myChart.resize();
                                    });
                                });
                            }
                        }
                    })
                });
            }
        };
    }])
    .directive('basicEmotionChartDir', ['$q', '$timeout', 'trsHttpService', function($q, $timeout, trsHttpService) {
        return {
            restrict: 'E',
            replace: true,
            template: "<div ng-style=\"myStyle\" ng-click=\"request(params)\"></div>",
            scope: {
                optionJsons: "="
            },
            link: function(scope, iElement, iAttrs, $eval, $rootScope) {
                $timeout(function() {
                    scope.myStyle = {
                        height: '300px',
                        width: '100%'
                    };
                    var myChart;
                    scope.$watch("optionJsons", function(newVal, oldVal) {
                        if (typeof newVal == 'object') {
                            if (angular.isDefined(scope.optionJsons)) {
                                var xAisData = [],
                                    yAisData = [];
                                var optionsData = scope.optionJsons;
                                for (var i = 0; i < optionsData.length; i++) {
                                    for (var y = 0, yData; yData = optionsData[i][1].data, y < yData.length; y++) {
                                        xAisData.push(optionsData[i][0].date + ' ' + yData[y][0].hour + ':00');
                                        yAisData.push(yData[y][1].value);
                                    }
                                }
                                var option = {
                                    tooltip: {
                                        trigger: 'axis',
                                        position: function(pt) {
                                            return [pt[0], '10%'];
                                        }
                                    },
                                    legend: {
                                        icon: 'rect',
                                        orient: 'horizontal',
                                        left: '50',
                                        data: ['情感值'],
                                    },
                                    brush: {
                                        xAxisIndex: 'all',
                                        brushLink: 'all',
                                        outOfBrush: {
                                            colorAlpha: 0.1
                                        },
                                    },
                                    dataZoom: [{
                                            show: true,
                                            realtime: true,
                                            start: 0,
                                            end: 20
                                        },
                                        {
                                            type: 'inside',
                                            realtime: true,
                                            start: 65,
                                            end: 85,
                                            backgroundColor: "rgba(47,69,84,0)",
                                        }
                                    ],
                                    xAxis: {
                                        type: 'category',
                                        boundaryGap: false,
                                        axisTick: {
                                            show: false
                                        },
                                        gridIndex: 0,
                                        data: xAisData,

                                    },
                                    yAxis: {
                                        type: 'value',
                                        gridIndex: 0,
                                        axisTick: {
                                            show: false
                                        }
                                    },
                                    series: [{
                                        name: '情感值',
                                        data: yAisData,
                                        color: ['#E3EDFF'],
                                        type: 'line',
                                        itemStyle: {
                                            normal: {
                                                color: '#d64541'
                                            }
                                        },
                                        areaStyle: {
                                            normal: {
                                                color: '#e9f1ff'
                                            }
                                        },
                                    }]
                                };
                                require(['echarts'], function(echarts) {
                                    if (myChart != null && myChart != "" && myChart != undefined) {
                                        myChart.dispose();
                                    }
                                    myChart = echarts.init(iElement[0]);
                                    myChart.setOption(option);
                                    myChart.on('brushSelected', function(params) {
                                        var mainSeries = params.batch[0].areas;
                                        var selectedItems = []; //选中区域的横纵标
                                        for (var i = 0; i < mainSeries.length; i++) {
                                            if (mainSeries[i].coordRange && mainSeries[i].coordRange.length > 0) {
                                                for (var j = 0; j < mainSeries[i].coordRange.length; j++) {
                                                    selectedItems.push(mainSeries[i].coordRange[j]);
                                                }
                                            }
                                        }
                                        if (selectedItems[0] < 0) {
                                            selectedItems[0] = 0;
                                            selectedItems[1] = 0;
                                        } else if (selectedItems[1] > xAisData.length) {
                                            selectedItems[0] = xAisData.length - 1;
                                            selectedItems[1] = xAisData.length - 1;
                                        } else if (JSON.stringify(selectedItems) === '[]' || selectedItems[0].length == 2) {
                                            return;
                                        }
                                        var endValue;
                                        if (xAisData.length == 1) {
                                            endValue = xAisData[0];
                                        } else {
                                            endValue = xAisData[selectedItems[1] - 1];
                                        }
                                        var timeValue = {
                                            startValue: xAisData[selectedItems[0]],
                                            endValue: endValue
                                        };
                                        scope.$emit('changeEmotionTimeRangeData', { timeValue: timeValue });
                                    });
                                    myChart.dispatchAction({
                                        type: 'brush',
                                        areas: [{
                                            brushType: 'lineX',
                                            coordRange: [0, 5],
                                            xAxisIndex: 0
                                        }]
                                    });
                                    // myChart.on('dataZoom',function(data){
                                    //     var option = myChart.getOption();
                                    //     var dz = option.dataZoom[0];
                                    //     var startValue = option.xAxis[0].data[dz.startValue];
                                    //     var endValue = option.xAxis[0].data[dz.endValue];
                                    //     var timeValue={
                                    //         startValue:startValue,
                                    //         endValue:endValue
                                    //     };
                                    //     scope.$emit('changeEmotionTimeRangeData',{timeValue:timeValue});
                                    // });
                                    window.addEventListener("resize", function() {
                                        myChart.resize();
                                    });
                                });
                            }
                        }
                    })
                });
            }
        };
    }])